module.exports = __webpack_public_path__ + "static/media/Day2.a101855d.jpg";